const tippyOptions = {
	placement: 'top',
	theme: 'fk',
}

import React from 'react';

export const LabelButton = React.forwardRef(({ content, iconClass, iconText, ...props }, ref) => {
	return ( 
		<a ref={ref} className='label-btn' data-tippy-content={content} data-tippy-options={JSON.stringify(tippyOptions)} {...props}>
			<span className={iconClass}>{iconText}</span>
		</a>
	);
});

export const LabelButtonUndo = React.forwardRef((props, ref) => {
	return <LabelButton ref={ref} content="Undo last action" iconClass='material-symbols-rounded' iconText='undo' {...props} />;
});

export const LabelButtonRedo = React.forwardRef((props, ref) => {
	return <LabelButton ref={ref} content="Redo last action" iconClass='material-symbols-rounded' iconText='redo' {...props} />;
});

export const LabelButtonCustomizeColumns = React.forwardRef((props, ref) => {
	return <LabelButton ref={ref} content="Customize columns" iconClass='fk-icons' iconText='customize' {...props} />;
});

export const LabelButtonDownload = React.forwardRef((props, ref) => {
	return <LabelButton ref={ref} content="Download" iconClass='fk-icons' iconText='download' {...props} />;
});